export default __webpack_public_path__ + "static/media/tren_components_switch.d5c3f783.png";